const config = {
    // TODO 注意：正式版发布时放开第一个，注释第二个
    // 请求服务器
    //  baseURL: process.env.NODE_ENV ==='production' ?'https://v5.api.5umovie.com':'http://psd.api.zhijiangfilm.com', //票时代API-正式环境
    // baseURL: process.env.NODE_ENV === 'production' ? 'http://psd.api.zhijiangfilm.com' : 'https://psdv6.h5.zhijiangfilm.com/prod-api', //票时代API-开发环境
    baseURL: process.env.NODE_ENV === 'production' ? 'https://psd.zhijiangfilm.com/prod-api' : 'https://psdv6.h5.zhijiangfilm.com/prod-api', //票时代API-开发环境
    dbApiURL: process.env.NODE_ENV === 'production' ? 'http://55.dbapi.zhijiangfilm.com:39101' : 'http://55.dbapi.zhijiangfilm.com:39101', //开发环境
    // 影院业务服务器
    cinemaURL: process.env.NODE_ENV === 'production' ? 'http://dev.cc.api.zhijiangfilm.com' : 'http://dev.cc.api.zhijiangfilm.com', //开发环境
    cinemaList: [
        {
            name: '浙影时代·翠苑店',
            innerCode: '11929',
        },
        {
            name: '浙影时代·新远西湖文化广场店（IMAX激光）',
            innerCode: '13459',
        },
        {
            name: '浙影时代·奥斯卡店',
            innerCode: '11930',
        },
        {
            name: '浙影时代·西溪欢乐城IMAX店',
            innerCode: '11935',
        },
        {
            name: '浙影时代·恒隆店',
            innerCode: '11931',
        },
        {
            name: '浙影时代·新农都店',
            innerCode: '11934',
        },
        {
            name: '浙影时代·和达店',
            innerCode: '11933',
        },
        {
            name: '浙影时代·富阳鹿山时代店',
            innerCode: '13039',
        },
        {
            name: '浙影时代·桐庐金球店',
            innerCode: '12530',
        },
        {
            name: '浙影时代·华影星空影城',
            innerCode: '16822',
        },
        {
            name:'浙影时代·慈溪新都汇店',
            innerCode:'12529'
        },
        {
            name:'浙影时代·宁波东门银泰店',
            innerCode:'12525'
        },
        {
            name:'浙影时代·玉环店',
            innerCode:'12537'
        },
        {
            name:'浙影时代·吉安万象广场店',
            innerCode:'12540'
        },
        {
            name:'浙影时代·密云店',
            innerCode:'11927'
        },
        {
            name:'浙影时代影城 名悦广场店',
            innerCode:'16167'
        },
        {
            name:'浙影时代·舟山金球凯虹广场店',
            innerCode:'12533'
        }
    ]
}
module.exports = config
